export default {
  "accountSource": "Account preference",
  "title": "Language",
  "preferencesTitle": "Language preferences",
  "profileDescription": "Choose how this dashboard is displayed for you.",
  "trigger": "Language: {{language}}",
  "displayed": "Displayed: {{language}}",
  "applyTo": "Apply to",
  "session": "This session",
  "account": "My account on this dashboard",
  "guest": "This tab",
  "impersonation": "This impersonation session",
  "browser": "Browser",
  "dashboard": "Dashboard default",
  "fallback": "English fallback",
  "sessionDescription": "Applies to tabs using this login until you sign out.",
  "accountDescription": "Used on this dashboard across browsers. Saving also clears this session’s override.",
  "guestDescription": "Used while signing in. Your account preference applies after sign-in.",
  "impersonationDescription": "The account’s saved language will not change.",
  "inherit": "Use account preference",
  "automatic": "Automatic",
  "inheritDescription": "Uses your account language, or Automatic if none is saved.",
  "automaticDescription": "Uses your browser language, then the dashboard default.",
  "apply": "Apply language",
  "save": "Save language",
  "resetSession": "Reset session language",
  "resetTab": "Reset tab language",
  "useAutomatic": "Use Automatic",
  "done": "Done",
  "notApplied": "Not applied",
  "loading": "Loading language preferences…",
  "loadError": "Could not load language preferences.",
  "retry": "Retry",
  "saving": "Saving language…",
  "saved": "Language saved.",
  "savedLoading": "Language saved. Loading translation…",
  "catalogError": "Translation could not load; showing {{language}}.",
  "savedCatalogError": "Language saved. Translation could not load; showing {{language}}.",
  "retryTranslation": "Retry translation",
  "saveError": "Language was not saved.",
  "unauthorized": "Sign in again to save your language.",
  "forbidden": "This language preference cannot be changed in this session.",
  "invalid": "Choose a supported language.",
  "conflict": "Language preference changed elsewhere. Review your choice and apply again.",
  "uncertain": "Could not confirm whether your language was saved.",
  "storageWarning": "This choice may be lost when you reload.",
  "stale": "Language preferences may be out of date.",
  "dashboardDefault": "Dashboard fallback language",
  "dashboardDefaultDescription": "Applies only when no personal or supported browser language resolves. Does not change the CLI language.",
  "unsetDefault": "No dashboard default (English fallback)"
} as const;
